
const layout = {
  state: {
    menuStatus: window.screen.width > 768 ? false : false, // pc端时菜单初始化展示，移动端初始化时隐藏
    isClose: false
  },
  mutations: {
    OPEN_MENU: (state, device) => {
      // state.menuStatus = window.screen.width > 768 ? true : false // pc端时菜单初始化展示，移动端初始化时隐藏
      state.menuStatus = device
      // console.log(state.menuStatus);

    },
    SET_IS_CLOSE: (state, isClose) => {
      state.isClose = isClose
    }
  },
  actions: {
    OpenMenu ({ commit, state }, data) {
      commit('OPEN_MENU', data)
    },
    isCollapse ({ commit, state }, data) {
      console.log();
      commit('SET_IS_CLOSE', !state.isClose)
    }
  }
}


export default layout



// WEBPACK FOOTER //
// ./src/store/modules/layout.js